import BACK_API from "../api/simulateAPI";


const getMunicipios = async (idMunicipio) => {
    const result = await BACK_API()
        .get(`simulation/municipios?departamento=${idMunicipio}`)
        .catch((error) => {
            console.log(error)
            throw error   
        })
    return result.data.sort((a, b) => {
      if (!a.name) return -1;
      if (!b.name) return 1;
      return a.name.localeCompare(b.name, "es", { sensitivity: "base" });
    });
}

export default getMunicipios